function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 53,
  cy: 41,
  r: 41,
  fill: "#4293F6",
  opacity: 0.1
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#2F66E3",
  fillRule: "evenodd",
  d: "M71.307 46.398c.36.18.645.51.765.87l1.625 4.856a1.113 1.113 0 0 1-.703 1.41l-4.362 1.46c-.3.075-.63.06-.9-.075l-2.07-1.032a.304.304 0 0 1-.166-.195l-1.173-3.508a.324.324 0 0 0-.42-.21l-3.283 1.099a.324.324 0 0 1-.42-.21l-1.098-3.282a.324.324 0 0 0-.42-.21l-3.508 1.173a.304.304 0 0 1-.255-.014l-6.33-3.008c-.855.736-1.964 1.307-2.953 1.638-5.486 1.835-11.248-1.038-13.083-6.524-1.835-5.486 1.038-11.248 6.524-13.083 5.486-1.835 11.248 1.038 13.128 6.51.3.974.452 2.023.378 3.148l18.724 9.187zm-35.084-9.59c.526 1.574 2.357 2.487 3.93 1.96 1.56-.496 2.487-2.356 1.96-3.93-.526-1.574-2.356-2.487-3.93-1.96-1.574.526-2.487 2.356-1.96 3.93zm15.928 2.547a.503.503 0 0 0-.45.9l18.034 8.994a.503.503 0 0 0 .45-.9L52.15 39.355z",
  clipRule: "evenodd",
  filter: "url(#a)"
});

var _ref4 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("filter", {
  id: "a",
  width: 105.75,
  height: 92.04,
  x: 0,
  y: 27,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), React.createElement("feOffset", {
  dy: 4
}), React.createElement("feGaussianBlur", {
  stdDeviation: 2
}), React.createElement("feColorMatrix", {
  values: "0 0 0 0 0.203922 0 0 0 0 0.368627 0 0 0 0 0.662745 0 0 0 0.15 0"
}), React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  mode: "multiply",
  result: "effect1_dropShadow"
}), React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), React.createElement("feOffset", {
  dy: 8
}), React.createElement("feGaussianBlur", {
  stdDeviation: 4
}), React.createElement("feColorMatrix", {
  values: "0 0 0 0 0.203922 0 0 0 0 0.368627 0 0 0 0 0.662745 0 0 0 0.15 0"
}), React.createElement("feBlend", {
  in2: "effect1_dropShadow",
  mode: "multiply",
  result: "effect2_dropShadow"
}), React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), React.createElement("feOffset", {
  dy: 16
}), React.createElement("feGaussianBlur", {
  stdDeviation: 8
}), React.createElement("feColorMatrix", {
  values: "0 0 0 0 0.203922 0 0 0 0 0.368627 0 0 0 0 0.662745 0 0 0 0.15 0"
}), React.createElement("feBlend", {
  in2: "effect2_dropShadow",
  mode: "multiply",
  result: "effect3_dropShadow"
}), React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), React.createElement("feOffset", {
  dy: 32
}), React.createElement("feGaussianBlur", {
  stdDeviation: 16
}), React.createElement("feColorMatrix", {
  values: "0 0 0 0 0.203922 0 0 0 0 0.368627 0 0 0 0 0.662745 0 0 0 0.15 0"
}), React.createElement("feBlend", {
  in2: "effect3_dropShadow",
  mode: "multiply",
  result: "effect4_dropShadow"
}), React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect4_dropShadow",
  result: "shape"
})));

var SvgKeyCircle = function SvgKeyCircle(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 106,
    height: 120,
    fill: "none",
    viewBox: "0 0 100 100",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgKeyCircle, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/key-circle.96dae74e.svg";
export { ForwardRef as ReactComponent };